import {range} from '@yandex-delivery/utils'
import dayjs, {duration} from 'dayjs'

/**
 * Генерирует массив часов, находящихся в промежутке от `startDateISO` до `endDateISO`
 * @param startDateISO Дата в формате ISO - левая граница промежутка
 * @param endDateISO Дата в формате ISO - правая граница промежутка
 * @returns массив часов, находящихся в промежутке от `startDateISO` до `endDateISO`
 */
export const getHoursInRange = (startDateISO: string, endDateISO: string): Array<string> => {
  const startDate = dayjs(startDateISO)
  const endDate = dayjs(endDateISO)

  if (startDate.isAfter(endDate)) {
    throw new Error('startDateISO must be earlier than endDateISO')
  }

  const difference = duration(endDate.diff(startDate))

  return range(startDate.hour(), startDate.hour() + difference.hours() + 1).map(hour => String(hour).padStart(2, '0'))
}
